/**
 * App-level Copilot UI shell — mounted once so chat state survives route changes.
 */
import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { useAISearchPanel } from '@hooks/useAISearchPanel';
import { useAuthStore } from '@store/auth.store';
import { DesktopChatPanel } from './DesktopChatPanel';
import { ChatbotMobileBottomPanel } from '../ChatbotMobileBottomPanel/ChatbotMobileBottomPanel';
import { FloatingAIToggleButton } from '../FloatingAIToggleButton/FloatingAIToggleButton';

export const CopilotAppShell: React.FC = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const { isVisible } = useAISearchPanel();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (!isAuthenticated) {
    return null;
  }

  return (
    <>
      <DesktopChatPanel />
      {isMobile && <ChatbotMobileBottomPanel open={isVisible} />}
      <FloatingAIToggleButton />
    </>
  );
};
